import React, { useMemo, useState } from "react";
import PropTypes from "prop-types";
import ReactTable from "react-table";

import { formatDate } from "../../../../helpers/date";

const CallBreakdown = ({ calls, isMobile }) => {
  const [pageSize, setPageSize] = useState(5);

  const columns = useMemo(
    () => [
      {
        Header: "Date",
        accessor: "arrival_date",
        Cell: ({ value }) => formatDate(value, "MM/dd/yy")
      },
      {
        Header: "Assigned To",
        accessor: "assigned_to",
        Cell: ({ value }) => (value ? value.full_name : "Unassigned")
      },
      {
        Header: "Tasks",
        accessor: "tasks",
        Cell: function getTaskName(row) {
          const serviceTasks = row.original.service?.tasks;
          return (
            <ul className="task-list">
              {row.value.map((task) => (
                <li key={task.id}>
                  {
                    serviceTasks.find((st) => st.id === task.service_task)?.task
                      .description
                  }
                </li>
              ))}
            </ul>
          );
        }
      },
      {
        Header: "Note",
        accessor: "billing_description"
      }
    ],
    []
  );

  const handleRowClick = (data) => {
    window.open(`/app/calls/${data.id}`);
  };

  const tableProps = {
    getTdProps: (state, rowInfo) => ({
      onClick: () => {
        handleRowClick(rowInfo.original);
      }
    })
  };

  return (
    <div className="itms-calls-container">
      <h1>Call Breakdown</h1>
      <div className="content-wrapper">
        <ReactTable
          {...tableProps}
          className="-highlight calls itms-calls"
          data={calls}
          columns={columns}
          showPageSizeOptions={!isMobile}
          defaultPageSize={calls.length < 5 ? calls.length : pageSize}
          onPageSizeChange={setPageSize}
          showPagination={calls.length > 5}
        />
      </div>
    </div>
  );
};

CallBreakdown.propTypes = {
  calls: PropTypes.array,
  isMobile: PropTypes.bool
};

CallBreakdown.defaultProps = {
  calls: [],
  isMobile: false
};

export default CallBreakdown;
